/* SmoothStep — interacciones (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.ss-reveal:not(.ss-visible), .ss-img-reveal:not(.ss-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ss-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ss-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initContadores(root) {
    var els = (root || document).querySelectorAll('[data-ss-contar]');
    if (!els.length) return;
    var animar = function (el) {
      var fin = parseFloat(el.getAttribute('data-ss-contar')) || 0;
      var dec = (el.getAttribute('data-ss-contar').split('.')[1] || '').length;
      if (reduce) { el.textContent = fin.toLocaleString('es-ES', { minimumFractionDigits: dec }); return; }
      var t0 = null, dur = 1600;
      var paso = function (t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var v = fin * (1 - Math.pow(1 - p, 3));
        el.textContent = v.toLocaleString('es-ES', { minimumFractionDigits: dec, maximumFractionDigits: dec });
        if (p < 1) requestAnimationFrame(paso);
      };
      requestAnimationFrame(paso);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initComparador(root) {
    (root || document).querySelectorAll('.ss-comp').forEach(function (c) {
      var r = c.querySelector('input[type=range]');
      if (!r || r.dataset.ok) return;
      r.dataset.ok = '1';
      var set = function () { c.style.setProperty('--pos', r.value + '%'); };
      r.addEventListener('input', set);
      set();
    });
  }

  function initGaleria(root) {
    (root || document).querySelectorAll('[data-ss-galeria]').forEach(function (g) {
      if (g.dataset.ok) return;
      g.dataset.ok = '1';
      var grandes = g.querySelectorAll('.ss-galeria__principal img');
      var minis = g.querySelectorAll('.ss-galeria__mini');
      var i = 0;
      var ir = function (n) {
        if (!grandes.length) return;
        i = (n + grandes.length) % grandes.length;
        grandes.forEach(function (im, k) { im.classList.toggle('ss-activa', k === i); });
        minis.forEach(function (m, k) { m.classList.toggle('ss-activa', k === i); });
      };
      minis.forEach(function (m, k) { m.addEventListener('click', function () { ir(k); }); });
      var p = g.querySelector('.ss-galeria__flecha--prev');
      var n = g.querySelector('.ss-galeria__flecha--next');
      if (p) p.addEventListener('click', function () { ir(i - 1); });
      if (n) n.addEventListener('click', function () { ir(i + 1); });
      var x0 = null;
      var pr = g.querySelector('.ss-galeria__principal');
      if (pr) {
        pr.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        pr.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) ir(dx < 0 ? i + 1 : i - 1);
          x0 = null;
        });
      }
    });
  }

  function formatoDinero(cents, formato) {
    var v = (cents / 100).toFixed(2);
    var partes = v.split('.');
    var coma = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + partes[1];
    var punto = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + partes[1];
    return (formato || '{{amount}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, partes[0])
      .replace(/\{\{\s*amount\s*\}\}/, punto);
  }

  function initProducto(root) {
    (root || document).querySelectorAll('[data-ss-producto]').forEach(function (s) {
      if (s.dataset.ok) return;
      s.dataset.ok = '1';
      var form = s.querySelector('form[action*="/cart/add"]');
      var idInput = form && form.querySelector('input[name="id"]');
      var btn = s.querySelector('[data-ss-add]');
      var btnTxt = btn ? btn.querySelector('span') : null;
      var precio = s.querySelector('[data-ss-precio]');
      var tachado = s.querySelector('[data-ss-tachado]');
      var datos = s.querySelector('[data-ss-variantes]');
      var formato = s.getAttribute('data-ss-formato');
      var textos = { add: s.getAttribute('data-ss-txt-add'), agotado: s.getAttribute('data-ss-txt-agotado') };
      var variantes = datos ? JSON.parse(datos.textContent) : [];

      // Variantes
      var radios = s.querySelectorAll('.ss-variantes input');
      var actualizar = function () {
        var sel = [];
        s.querySelectorAll('.ss-variantes').forEach(function (grupo) {
          var c = grupo.querySelector('input:checked');
          sel.push(c ? c.value : null);
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, k) { return o === sel[k]; }); });
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (precio) precio.textContent = formatoDinero(v.price, formato);
        if (tachado) {
          if (v.compare_at_price && v.compare_at_price > v.price) { tachado.textContent = formatoDinero(v.compare_at_price, formato); tachado.hidden = false; }
          else tachado.hidden = true;
        }
        if (btn) { btn.disabled = !v.available; if (btnTxt) btnTxt.textContent = v.available ? textos.add : textos.agotado; }
        document.querySelectorAll('[data-ss-barra-precio]').forEach(function (el) { el.textContent = formatoDinero(v.price, formato); });
      };
      radios.forEach(function (r) { r.addEventListener('change', actualizar); });

      // Cantidad
      var q = s.querySelector('.ss-cantidad input');
      s.querySelectorAll('.ss-cantidad button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(q.value || '1', 10) + parseInt(b.getAttribute('data-paso'), 10);
          q.value = Math.max(1, n);
        });
      });

      // Packs: cada tarjeta fija la cantidad; el descuento lo aplica Shopify en el carrito
      var packs = s.querySelectorAll('.ss-pack input');
      if (packs.length && q) {
        var precioBase = function () {
          var v = variantes.find(function (x) { return String(x.id) === String(idInput.value); });
          return v ? v.price : null;
        };
        var pintarPacks = function () {
          var base = precioBase();
          packs.forEach(function (r) {
            var total = base === null ? null : base * parseInt(r.value, 10) - parseInt(r.getAttribute('data-descuento') || '0', 10);
            var el = r.closest('.ss-pack').querySelector('[data-ss-pack-total]');
            if (el && total !== null) el.textContent = formatoDinero(total, formato);
            if (r.checked) {
              q.value = r.value;
              var txt = el ? el.textContent : '';
              document.querySelectorAll('[data-ss-barra-precio]').forEach(function (b) { b.textContent = txt; });
            }
          });
        };
        packs.forEach(function (r) { r.addEventListener('change', pintarPacks); });
        radios.forEach(function (r) { r.addEventListener('change', pintarPacks); });
      }

      // Añadir al carrito sin salir de la página y abrir el carrito
      if (form) {
        form.addEventListener('submit', function (e) {
          if (!window.fetch) return;
          e.preventDefault();
          var err = s.querySelector('.ss-compra__error');
          if (btn) btn.setAttribute('aria-busy', 'true');
          fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: idInput.value, quantity: parseInt(q ? q.value : 1, 10) || 1 }] })
          }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
            .then(function (res) {
              if (!res.ok) { if (err) err.textContent = res.j.description || res.j.message || 'No se pudo añadir.'; return; }
              window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
            })
            .catch(function () { form.submit(); })
            .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
        });
      }

      // Barra fija
      var barra = document.querySelector('.ss-barra');
      if (barra && btn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var pasado = !e.isIntersecting && e.boundingClientRect.top < 0;
            barra.classList.toggle('ss-visible', pasado);
          });
        });
        io.observe(btn);
        var bb = barra.querySelector('button');
        if (bb) bb.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else btn.click(); });
      }
    });
  }

  function initTodo(root) {
    initReveal(root); initContadores(root); initComparador(root); initGaleria(root); initProducto(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();

  // Editor de Shopify: reiniciar al cargar/editar secciones
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
